import moment from 'moment-business-days'

import {getSelectableDateRange, setBusinessDays} from '../../../fields/dateTime/dateTime.utils'
import {DateTimeConfiguration, DateTimeForm} from '../../../fields/dateTime/types'
import {MixConfiguration} from '../../../fields/mix/types'
import {CreateFormInput} from '../types'

export const buildDateTimeForm = (
  configuration: CreateFormInput<DateTimeConfiguration & MixConfiguration>
): DateTimeForm => {
  const {
    configuration: {
      dateTime: {businessDays, businessHours, holidays},
      mix: {contracts}
    }
  } = configuration

  const originalLocale = moment.locale()
  setBusinessDays(originalLocale, businessDays, holidays)

  // Calculate default dateTime using minDate from selectableDateRange
  const processContract = contracts.length > 0 ? contracts[0] : undefined
  const availableDateRange = processContract?.dateRange

  let defaultDateTime: string[] = []

  if (businessHours && businessDays) {
    const selectableDateRange = getSelectableDateRange(
      availableDateRange,
      businessHours,
      businessDays
    )
    defaultDateTime = [selectableDateRange.minDate.toISOString()]
  }

  return {
    dateTime: defaultDateTime
  }
}
